export default __webpack_public_path__ + "static/media/hsabank-logo.48d22b2e.png";